import { memo, useCallback, useMemo } from "react";

import { FeatureIslandHeader } from "@/components/features/_layouts";
import type { ForNodeType } from "@/components/features/_model/types";
import { HeaderUpdateButtonAndInSaleSwitch } from "@/components/features/items/edit/_shared/ui/components/header/header-update-button-and-in-sale-switch";

type Props = {
	title: string;
	// 公開・非公開
	inSale: ForNodeType<boolean>;
	// 編集済みか
	isDirty: boolean;
	// エラー判定
	hasError: boolean;

	// ディスカウントの公開
	onPublish: () => void;
	// ディスカウントの非公開
	onUnpublish: () => void;
	//
	onSave: () => void;
};

export const DiscountEditHeaderComposition = memo(
	({ title, inSale, isDirty, hasError, onPublish, onUnpublish, onSave }: Props) => {
		/**
		 * 公開・非公開
		 */
		const handleChangeInSale = useCallback(() => {
			if (inSale.value) {
				onUnpublish();
			} else {
				onPublish();
			}
		}, [inSale, onPublish, onUnpublish]);
		/**
		 * 保存
		 */
		const handleClickSave = useCallback(() => {
			onSave();
		}, [onSave]);

		const disabled = useMemo(() => !isDirty || hasError, [isDirty, hasError]);

		return (
			<FeatureIslandHeader
				title={title}
				rightChildren={
					<HeaderUpdateButtonAndInSaleSwitch
						updateButton={{
							isValid: !disabled,
							handleClick: handleClickSave,
						}}
						inSaleSwitch={{
							inSale,
							handleChangeInSale,
						}}
					/>
				}
			/>
		);
	},
);
